import styled from "styled-components";
import BaseInput from "../atoms/BaseInput";
import CancelIcon from '@mui/icons-material/Cancel';

const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 50px;
`;
const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
`;
const ClearIcon = styled(CancelIcon)`
  color: ${(props) => props.theme.colors.text.assistive};
  cursor: pointer;
`
const StyledBaseInput = styled(BaseInput)`
  padding-right: ${({ $hasValue }) => ($hasValue ? "48px" : "16px")};
  ${({ $error, theme }) => $error && `
    border-color: ${theme.colors.status.error} ;
  `}
`

const ClearableInput =({ placeholder, value, onChange, readOnly, $error, ...props}) => {
  // value 초기화
    const handleClear = (e) => {
      e.preventDefault();
      onChange({ target: { value: "" } });
    };

    return (
      <Container>
        <StyledBaseInput
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          $hasValue={Boolean(value)}
          readOnly={readOnly}
          $error={$error}
          {...props}
        />
        {value && !readOnly && (
          <IconButton type="button" onClick={handleClear}>
            <ClearIcon />
          </IconButton>
        )}
      </Container>
    );
  }
export default ClearableInput;
